if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        const idInput = this.form.querySelector('[name="id"]');
        if (idInput) {
          idInput.disabled = false;
        }

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');

        if (!this.submitButton) return;

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.submitButton) return;

        if (
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.error = false;

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector(
          '.loading-overlay__spinner'
        );

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        try {
          const config = fetchConfig('javascript');

          config.headers['X-Requested-With'] = 'XMLHttpRequest';

          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);

          if (this.cart) {
            formData.append(
              'sections',
              this.cart
                .getSectionsToRender()
                .map((section) => section.id)
            );

            formData.append(
              'sections_url',
              window.location.pathname
            );

            this.cart.setActiveElement(document.activeElement);
          }

          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => {
              if (!response.ok) {
                throw new Error(
                  `Cart request failed: ${response.status}`
                );
              }

              return response.json();
            })
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector(
                    '.sold-out-message'
                  );

                if (soldOutMessage) {
                  this.submitButton.setAttribute(
                    'aria-disabled',
                    'true'
                  );

                  const buttonText =
                    this.submitButton.querySelector('span');

                  if (buttonText) {
                    buttonText.classList.add('hidden');
                  }

                  soldOutMessage.classList.remove('hidden');
                }

                this.error = true;
                return;
              }

              if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              this.error = false;

              const quickAddModal =
                this.closest('quick-add-modal');

              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );

                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((error) => {
              console.error(
                'SR Takat cart add error:',
                error
              );

              this.error = true;

              this.handleErrorMessage(
                'Unable to add this product to cart. Please try again.'
              );
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');

              if (spinner) {
                spinner.classList.add('hidden');
              }

              if (
                this.cart &&
                this.cart.classList.contains('is-empty')
              ) {
                this.cart.classList.remove('is-empty');
              }

              if (!this.error) {
                this.submitButton.removeAttribute(
                  'aria-disabled'
                );
              }
            });
        } catch (error) {
          console.error(
            'SR Takat product form error:',
            error
          );

          this.error = true;

          this.submitButton.classList.remove('loading');

          if (spinner) {
            spinner.classList.add('hidden');
          }

          this.submitButton.removeAttribute(
            'aria-disabled'
          );

          this.handleErrorMessage(
            'Unable to add this product to cart. Please try again.'
          );
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}